import React from 'react';
import { usePermission } from './usePermission';
import { Module, Action } from '@/config/permission-matrix.config';
import { Tooltip } from '@/components/ui';

interface AuthMaskProps {
  module: Module;
  action?: Action; // Thường là 'view_sensitive' hoặc tương đương
  permissionKey?: string; // Có thể truyền key trực tiếp VD: 'costs.view_sensitive'
  value: React.ReactNode;
  mask?: string;
}

/**
 * AuthMask - Component bảo vệ dữ liệu nhạy cảm
 * Hiển thị •••• nếu người dùng không đủ quyền
 */
export const AuthMask: React.FC<AuthMaskProps> = ({
  module,
  action = 'view',
  permissionKey,
  value,
  mask = '••••',
}) => {
  const { can } = usePermission();
  
  // Kiểm tra quyền theo key hoặc module.action
  const hasPermission = permissionKey 
    ? (usePermission() as any).permissions[permissionKey.split('.')[0]]?.includes(permissionKey.split('.')[1])
    : can(module, action);

  // Lưu ý: handle can() với permissionKey linh hoạt hơn nếu cần
  
  if (!hasPermission) {
    return (
      <Tooltip content="Bạn không có quyền xem thông tin nhạy cảm này">
        <span className="font-mono text-gray-400 cursor-help select-none">
          {mask}
        </span>
      </Tooltip>
    );
  }

  return <>{value}</>;
};
